import { apiCall } from "./service";
import {
  URL_CREATE_DELETION_REQUESTS,
  URL_CONFIRM_DELETION_REQUEST,
  URL_CANCEL_DELETION_REQUESTS,
  URL_RESEND_DELETION_REQUESTS_EMAIL
} from "./URL";


export const deletionRequestService = {

  createDeletionRequest(deletionRequestDto) {
    return apiCall.post({
      url: URL_CREATE_DELETION_REQUESTS,
      params: deletionRequestDto,
    });
  },

  confirmDeletionRequest(id) {
    return apiCall.put({
      url: `${URL_CONFIRM_DELETION_REQUEST(id)}`
    });
  },

  cancelDeletionRequest(deletionRequestDto) {
    return apiCall.put({
      url: URL_CANCEL_DELETION_REQUESTS,
      params: deletionRequestDto,
    });
  },

  resendDeletionRequestEmail(deletionRequestDto) {
    return apiCall.post({
      url: URL_RESEND_DELETION_REQUESTS_EMAIL,
      params: deletionRequestDto,
    });
  },
};

export default deletionRequestService;
